import React from 'react';
import classnames from 'classnames';
import './NumberInput.scss';

const NumberInput = ({ className = '', ...otherProps }) => (
  <input
    type="number"
    {...otherProps}
    className={classnames('number-input', className)}
  />
);

export default NumberInput;
